import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      gap: 16px;
    }
  `}
`

export const ActionButtons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-bottom: 24px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column;
    }
  `}
`

export const NotificationMessage = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    margin-top: 24px;
    color: #283897;
    font-weight: 700;

    @media (max-width: ${theme.screenSizes.laptop}) {
      gap: 16px;
    }
  `}
`
